import { localStorage } from './local-storage'

// Merkt sich Spaces, bei denen die Payment-Query nachweislich leer war.
//
// Warum localStorage und nicht State: der Space-Wechsel läuft über
// `restartDashboard()`, und das ist ein echter Full Reload
// (`window.location.assign`, siehe use-restart-dashboard.js). In-Memory
// überlebt das nicht. Bei `signOut` räumt `localStorage.clear()` mit auf.
//
// Warum überhaupt gemerkt: die Payment-Auth-Regel ist
// `groupsField: "partner_id"` und der PreTokenGeneration-Trigger legt nur den
// *aktiven* Partner in die Cognito-Groups. Eine Payment-Query für einen fremden
// Partner läuft nicht auf einen Fehler, sondern durch den generierten
// authFilter in eine leere Liste — für den Client also nicht von „kein Payment
// vorhanden" unterscheidbar. Der Payment-Status fremder Spaces ist damit
// client-seitig nicht abfragbar; die einzige verlässliche Quelle ist der
// tatsächlich beobachtete accessDenied-Fall für den jeweils aktiven Space.
const STORAGE_KEY = 'spaces-without-payment'

const read = () => {
  try {
    const parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]')
    return Array.isArray(parsed) ? parsed.filter((id) => !!id) : []
  } catch {
    // krummer Eintrag darf den Login nicht killen
    return []
  }
}

const write = (space_ids) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify([...new Set(space_ids)]))
}

export const getSpacesWithoutPayment = () => read()

export const isSpaceWithoutPayment = (space_id) =>
  !!space_id && read().includes(space_id)

export const markSpaceWithoutPayment = (space_id) => {
  if (!space_id) return

  const space_ids = read()
  if (space_ids.includes(space_id)) return

  write([...space_ids, space_id])
}

// Gegenstück: sobald ein Space wieder eine Payment liefert, muss die Markierung
// weg — sonst bleibt ein zwischenzeitlich verlängerter Account für immer als
// „kein Zugang" markiert.
export const unmarkSpaceWithoutPayment = (space_id) => {
  if (!space_id) return

  const space_ids = read()
  if (!space_ids.includes(space_id)) return

  write(space_ids.filter((id) => id !== space_id))
}
